module.exports = __webpack_public_path__ + "static/media/red-dot-icon.df68f1ed.svg";